import { useEffect } from 'react';

import { selectCurrentRoute } from '../store/route/route.selectors';
import { stepActions } from '../store/step/step.actions';
import { selectCurrentStep } from '../store/step/step.selectors';
import { useAppDispatch, useSelector } from '../store/utils';

function IndexPage() {
  const step = useSelector(selectCurrentStep);
  const route = useSelector(selectCurrentRoute);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (step !== 'region' && route === '/') {
      dispatch(stepActions.calculateInitialStep());
    }
  }, [step, route, dispatch]);

  // Step sagas handles navigation
  return null;
}

export default IndexPage;
